
document.addEventListener("DOMContentLoaded", () => {
    const moveSalepifyEmbed = () => {
        const widget = document.querySelector(".salepify-embed-widget__container");
        const target = document.querySelector("product-form.product-form");

        if (!widget || !target) return;
        if (target.nextElementSibling === widget) return;

        target.insertAdjacentElement("afterend", widget);
    };

    let rafId = null;
    const scheduleMove = () => {
        if (rafId) return;

        rafId = requestAnimationFrame(() => {
            rafId = null;
            moveSalepifyEmbed();
        });
    };

    scheduleMove();

    const observer = new MutationObserver(() => {
        scheduleMove();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
});
